import { Controller } from "@hotwired/stimulus"
import Chart from "chart.js/auto"

export default class extends Controller {
    static targets = ["canvas"]
    static values = {
        labels: Array,
        data: Array,
        label: String,
        color: { type: String, default: '79, 70, 229' } // Default Indigo
    }

    connect() {
        this.renderChart()
    }

    renderChart() {
        const ctx = this.canvasTarget.getContext('2d')

        const gradient = ctx.createLinearGradient(0, 0, 0, 400)
        gradient.addColorStop(0, `rgba(${this.colorValue}, 0.15)`)
        gradient.addColorStop(1, `rgba(${this.colorValue}, 0.01)`)

        const config = {
            type: 'line',
            data: {
                labels: this.labelsValue,
                datasets: [{
                    label: this.labelValue || 'Risk Trend',
                    data: this.dataValue,
                    fill: true,
                    backgroundColor: gradient,
                    borderColor: `rgb(${this.colorValue})`,
                    borderWidth: 3,
                    pointBackgroundColor: '#fff',
                    pointBorderColor: `rgb(${this.colorValue})`,
                    pointBorderWidth: 2,
                    pointRadius: 4,
                    pointHoverRadius: 6,
                    pointHoverBackgroundColor: `rgb(${this.colorValue})`,
                    pointHoverBorderColor: '#fff',
                    pointHoverBorderWidth: 3,
                    tension: 0.4
                }]
            },
            options: {
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    legend: { display: false },
                    tooltip: {
                        backgroundColor: 'rgba(255, 255, 255, 0.95)',
                        titleColor: '#1e293b',
                        bodyColor: '#1e293b',
                        padding: 12,
                        borderColor: 'rgba(0,0,0,0.05)',
                        borderWidth: 1,
                        usePointStyle: true,
                        callbacks: {
                            label: (context) => ` Risk: ${context.parsed.y}%`
                        }
                    }
                },
                scales: {
                    x: {
                        grid: { display: false },
                        ticks: {
                            color: 'rgba(100, 116, 139, 0.5)',
                            font: { size: 10, weight: '700' }
                        }
                    },
                    y: {
                        beginAtZero: true,
                        max: 100,
                        grid: {
                            color: 'rgba(0,0,0,0.03)',
                            drawBorder: false
                        },
                        ticks: {
                            color: 'rgba(100, 116, 139, 0.5)',
                            font: { size: 10, weight: '700' },
                            stepSize: 25,
                            callback: (value) => value + '%'
                        }
                    }
                }
            }
        }

        this.chart = new Chart(this.canvasTarget, config)
    }

    disconnect() {
        if (this.chart) {
            this.chart.destroy()
        }
    }
}
